import { HelperService } from './../../Services/helper.service';
import { ItemTreeType } from 'src/app/models/enum/item-tree.enum';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-type-tree-icons',
  templateUrl: './item-type-tree-icons.component.html',
  styleUrls: ['./item-type-tree-icons.component.css']
})
export class ItemTypeTreeIconsComponent  {
  @Input() itemType: ItemTreeType;

  constructor(public helper: HelperService) { }

}
